// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'

import {Popup, Toast} from 'mint-ui'
import 'mint-ui/lib/style.css'

import * as api from '@/api'
import * as util from '@/public/util'
import { redirectToTeam, redirectToError } from '@/public/redirectTo'
import { getRiskData } from '@/public/getRiskData.js'

Vue.component(Popup.name, Popup)
Vue.component(Toast.name, Toast)
Vue.config.productionTip = false

let {
  actCode,
  source,
  markId,
  pin
} = util.parseUrlSearchToObj()

if (!markId) {
  api.buildTeam({
    reqData: JSON.stringify({
      actCode,
      source,
      riskDeviceParam: JSON.stringify(getRiskData())
    })
  }).then(teamInfo => {
    redirectToTeam(teamInfo)
  })
} else {
  let [contentData] = window.data_source.activities.filter(item => {
    return item.actCode === actCode
  })
  if (!contentData) {
    redirectToError()
  } else {
    document.title = contentData.documentTitle
    window.contentData = contentData
    // console.log('contents', window.contentData.contents)

    let params = {
      reqData: JSON.stringify({
        actCode,
        ukey: markId,
        source,
        riskDeviceParam: JSON.stringify(getRiskData())
      })
    }

    api.joinBuildTeam(params).then((resultData) => {
      if (resultData.code === '10006zt' || resultData.code === '10008zt') {
        api.isUserBeloneTeam(params).then(res => {
          // 新参团人员, 需要开新团,重定向
          if (res.code === '10016zt') {
            api.buildTeam({
              reqData: JSON.stringify({
                actCode,
                source,
                riskDeviceParam: JSON.stringify(getRiskData())
              })
            }).then(teamInfo => {
              redirectToTeam(teamInfo)
            })
          } else {
            /* eslint-disable no-new */
            new Vue({
              el: '#app',
              components: { App },
              template: '<App/>'
            })
          }
        })
      }

      /* eslint-disable no-new */
      new Vue({
        el: '#app',
        components: { App },
        template: '<App/>'
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/pages/activity/activity.js